import { defineMessages } from 'react-intl';

const translations = {
  labelIdle: {
    id: 'fileUpload.labelIdle',
    defaultMessage:
      'Drag & Drop your files or <span class="filepond--label-action"> Browse </span>',
    description: 'File upload labelIdle',
  },
  labelInvalidField: {
    id: 'fileUpload.labelInvalidField',
    defaultMessage: 'Field contains invalid files',
    description: 'File upload labelInvalidField',
  },
  labelFileWaitingForSize: {
    id: 'fileUpload.labelFileWaitingForSize',
    defaultMessage: 'Waiting for size',
    description: 'File upload labelFileWaitingForSize',
  },
  labelFileSizeNotAvailable: {
    id: 'fileUpload.labelFileSizeNotAvailable',
    defaultMessage: 'Size not available',
    description: 'File upload labelFileSizeNotAvailable',
  },
  labelFileLoading: {
    id: 'fileUpload.labelFileLoading',
    defaultMessage: 'Loading',
    description: 'File upload labelFileLoading',
  },
  labelFileLoadError: {
    id: 'fileUpload.labelFileLoadError',
    defaultMessage: 'Error during load',
    description: 'File upload labelFileLoadError',
  },
  labelFileProcessing: {
    id: 'fileUpload.labelFileProcessing',
    defaultMessage: 'Uploading',
    description: 'File upload labelFileProcessing',
  },
  labelFileProcessingComplete: {
    id: 'fileUpload.labelFileProcessingComplete',
    defaultMessage: 'Upload complete',
    description: 'File upload labelFileProcessingComplete',
  },
  labelFileProcessingAborted: {
    id: 'fileUpload.labelFileProcessingAborted',
    defaultMessage: 'Upload cancelled',
    description: 'File upload labelFileProcessingAborted',
  },
  labelFileProcessingError: {
    id: 'fileUpload.labelFileProcessingError',
    defaultMessage: 'Error during upload',
    description: 'File upload labelFileProcessingError',
  },
  labelFileProcessingRevertError: {
    id: 'fileUpload.labelFileProcessingRevertError',
    defaultMessage: 'Error during revert',
    description: 'File upload labelFileProcessingRevertError',
  },
  labelFileRemoveError: {
    id: 'fileUpload.labelFileRemoveError',
    defaultMessage: 'Error during remove',
    description: 'File upload labelFileRemoveError',
  },
  labelTapToCancel: {
    id: 'fileUpload.labelTapToCancel',
    defaultMessage: 'tap to cancel',
    description: 'File upload labelTapToCancel',
  },
  labelTapToRetry: {
    id: 'fileUpload.labelTapToRetry',
    defaultMessage: 'tap to retry',
    description: 'File upload labelTapToRetry',
  },
  labelTapToUndo: {
    id: 'fileUpload.labelTapToUndo',
    defaultMessage: 'tap to undo',
    description: 'File upload labelTapToUndo',
  },
  labelButtonRemoveItem: {
    id: 'fileUpload.labelButtonRemoveItem',
    defaultMessage: 'Remove',
    description: 'File upload labelButtonRemoveItem',
  },
  labelButtonAbortItemLoad: {
    id: 'fileUpload.labelButtonAbortItemLoad',
    defaultMessage: 'Abort',
    description: 'File upload labelButtonAbortItemLoad',
  },
  labelButtonRetryItemLoad: {
    id: 'fileUpload.labelButtonRetryItemLoad',
    defaultMessage: 'Retry',
    description: 'File upload labelButtonRetryItemLoad',
  },
  labelButtonAbortItemProcessing: {
    id: 'fileUpload.labelButtonAbortItemProcessing',
    defaultMessage: 'Cancel',
    description: 'File upload labelButtonAbortItemProcessing',
  },
  labelButtonUndoItemProcessing: {
    id: 'fileUpload.labelButtonUndoItemProcessing',
    defaultMessage: 'Undo',
    description: 'File upload labelButtonUndoItemProcessing',
  },
  labelButtonRetryItemProcessing: {
    id: 'fileUpload.labelButtonRetryItemProcessing',
    defaultMessage: 'Retry',
    description: 'File upload labelButtonRetryItemProcessing',
  },
  labelButtonProcessItem: {
    id: 'fileUpload.labelButtonProcessItem',
    defaultMessage: 'Upload',
    description: 'File upload labelButtonProcessItem',
  },
  labelMaxFileSizeExceeded: {
    id: 'fileUpload.labelMaxFileSizeExceeded',
    defaultMessage: 'File is too large',
    description: 'File upload labelMaxFileSizeExceeded',
  },
  labelMaxFileSize: {
    id: 'fileUpload.labelMaxFileSize',
    defaultMessage: 'Maximum file size is {filesize}',
    description: 'File upload labelMaxFileSize',
  },
  labelMaxTotalFileSizeExceeded: {
    id: 'fileUpload.labelMaxTotalFileSizeExceeded',
    defaultMessage: 'Maximum total size exceeded',
    description: 'File upload labelMaxTotalFileSizeExceeded',
  },
  labelMaxTotalFileSize: {
    id: 'fileUpload.labelMaxTotalFileSize',
    defaultMessage: 'Maximum total file size is {filesize}',
    description: 'File upload labelMaxTotalFileSize',
  },
  labelFileTypeNotAllowed: {
    id: 'fileUpload.labelFileTypeNotAllowed',
    defaultMessage: 'File of invalid type',
    description: 'File upload labelFileTypeNotAllowed',
  },
  fileValidateTypeLabelExpectedTypes: {
    id: 'fileUpload.fileValidateTypeLabelExpectedTypes',
    defaultMessage: 'Expects file type {allTypes}',
    description: 'File upload fileValidateTypeLabelExpectedTypes',
  },
  duplicateFileDialog: {
    title: {
      id: 'fileUpload.duplicateFileDialog.title',
      defaultMessage: 'File already exists',
      description: 'Title of the duplicate file dialog',
    },
    description: {
      id: 'fileUpload.duplicateFileDialog.description',
      defaultMessage: 'The file "{filename}" already exists in this folder',
      description: 'Description of the duplicate file dialog',
    },
    buttons: {
      cancel: {
        id: 'fileUpload.duplicateFileDialog.buttons.cancel',
        defaultMessage: 'Cancel',
        description: 'Label of the cancel action of the duplicate file dialog',
      },
      resolve: {
        id: 'fileUpload.duplicateFileDialog.buttons.resolve',
        defaultMessage: 'Re-upload',
        description: 'Label of the resolve action of the duplicate file dialog',
      },
      upsert: {
        id: 'fileUpload.duplicateFileDialog.buttons.upsert',
        defaultMessage: 'Overwrite',
        description: 'Label of the upsert action of the duplicate file dialog',
      },
    },
  },
};

export default defineMessages(translations);
